<div class="justify-between">
  <div class="text-xl text-gray-700 font-bold pb-4">
    Ocorrências
  </div>
  <!-- <div class="mr-8">
    <button mat-button class="btn-add" (click)="createItem()">Adicionar</button>
  </div> -->
  <!--  @if (checkPermission('criar')) {-->

  <!--  }-->

  <mat-card class="card-style">
    <occurrence-create (responseCreate)="uploadList('new')" [dataEdit]="data" />
  </mat-card>

  <div>
    <div class="mt-4">
      <!--    @if (checkPermission('pesquisar-paginado')) {-->
      <!--    <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
      <!--    <form-client-search-->
      <!--      [search]="inputSearch"-->
      <!--      [listSearch]="listSearch"-->
      <!--      (responseSearch)="search($event)"-->
      <!--    />-->
      <!--    }-->
      <div>
        @if (!loading) {
        <div>
          <table-list-simple [dataSource]="itemsList" [columns]="columns" (selectItem)="editItem($event)"
            (viewItem)="editItem($event)" />
          @if (itemsList.length > 0) {
          <mat-paginator [length]="numberRows" [pageSize]="rows" [pageIndex]="page - 1"
            [pageSizeOptions]="[5, 10, 20, 30]" (page)="onPageEvent($event)">
          </mat-paginator>
          <!-- <pagination
              [currentPage]="page"
              [pageSize]="rows"
              [totalRecords]="numberRows"
              (pageChanged)="pageChanged($event)"
            /> -->
          }
        </div>
        } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        }
      </div>
    </div>
  </div>
</div>